import React from "react";

export default function PersonalInfoAdminSection({
  lang,
  personalInfo,
  setPersonalInfo,
  savePersonalInfo
}) {
  if (!personalInfo) return null;

  return (
    <section className="section">
      <h2 className="sectionTitle">Personal Info ({lang})</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          name="name"
          value={personalInfo.name || ""}
          onChange={e => setPersonalInfo({ ...personalInfo, name: e.target.value })}
          placeholder="Nombre"
          className="input"
        />
        <input
          name="title"
          value={personalInfo.title || ""}
          onChange={e => setPersonalInfo({ ...personalInfo, title: e.target.value })}
          placeholder="Título"
          className="input"
        />
        <textarea
          name="description"
          value={personalInfo.description || ""}
          onChange={e => setPersonalInfo({ ...personalInfo, description: e.target.value })}
          placeholder="Descripción"
          className="input"
          rows={4}
          style={{ resize: "vertical" }}
        />
        <button
          onClick={savePersonalInfo}
          className="button"
          style={{ alignSelf: "flex-start", marginTop: "0.5rem" }}
        >
          Guardar Personal Info
        </button>
      </div>
    </section>
  );
}